import {PreviewAlert} from "components/preview-alert"
import {AudioControls} from "@/components/audioPlayer";
import {Toaster} from "@/components/ui/toaster";
import {useEffect} from "react";
import {reloadRevive} from "@/lib/utils";
import {Footer, Header, Preheader} from "@/components/regions";
import { GoogleAnalytics } from '@next/third-parties/google'

export const runtime = 'edge'

export function LayoutAccount({children}) {

  useEffect(() => {
    reloadRevive();
  }, []);

    return (
      <div className="bg-background">
        <PreviewAlert/>
        <header className="sticky z-50 top-0">
          <Preheader/>
          <Header/>
        </header>

        <main>{children}</main>

        <Footer/>
        <div className='ici'>
          <AudioControls/>
        </div>
        <GoogleAnalytics gaId="G-NTRJ5B3KBS" />
        <Toaster/>
      </div>
    )
}
